import React, { useEffect, useState, useRef, Component } from 'react';
import moment from 'moment';
import {
    format, startOfMonth, endOfMonth, differenceInDays, addDays, getMonth, getYear,
    endOfToday, differenceInCalendarDays, subDays, isMonday, isTuesday, isWednesday, isThursday,
    isFriday, isSaturday, isSunday, isBefore, startOfToday, isAfter, isSameDay, getDay
} from 'date-fns';
import commonFunction from '../../../../lib/utils/common';
import { id } from 'date-fns/locale';
// import styles from "./calendar.module.css";

const MonthList = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']

const weekList = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
// const weekday = ["Sun" ,"Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
const weekday = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

export default class MobileCalender extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dateFormat: !commonFunction.isValueEmpty(this.props.dateFormat) ? this.props.dateFormat : "dd/MM/yyyy",
            isCalendarVisible: false,
            numberOfClicks: 0,
            twoCalendarsArray: [],
            isDoubleSelection: !commonFunction.isValueEmpty(this.props.doubleSelection) ? this.props.doubleSelection : false,
            dateLimitArr: this.props.startDateLimit,
            currentMonths: [getMonth(startOfMonth(new Date()))],
            selectedMonthStartDate: startOfMonth(startOfToday()),
            selectedMonthEndDate: endOfMonth(startOfMonth(new Date())),
            // startDate: this.props.startDate,
            endDate: this.props.endDate,
            hoverEndDate: this.props.endDate,
            totalDays: "",
            pageX: "",
            pageY: "",
            initPageX: "",
            initPageY: "",
            totalMonths: !commonFunction.isValueEmpty(this.props.totalMonths) ? this.props.totalMonths : 12,
            serviceType: this.props.serviceType ? this.props.serviceType : "",
            totalNights: '',
            activeBox: "checkin", // "checkin" or "checkout"
        };
        this.debouncedOnClickDateCell = this.debounce(this.onClickDateCell, 10);

    }
    componentDidMount() {
        this.setState({
            currentMonths: this.props.type === "double" ? !commonFunction.isValueEmpty(this.state.dateLimitArr) ?
                [getMonth(startOfMonth(new Date(this.specDateEle(this.state.dateLimitArr, 'y'), this.specDateEle(this.state.dateLimitArr, 'm'), this.specDateEle(this.state.dateLimitArr, 'd')))),
                getMonth(startOfMonth(new Date(this.specDateEle(this.state.dateLimitArr, 'y'), this.specDateEle(this.state.dateLimitArr, 'm'), this.specDateEle(this.state.dateLimitArr, 'd')))) + 1] :
                [getMonth(startOfMonth(new Date())), getMonth(startOfMonth(new Date())) + 1] : !commonFunction.isValueEmpty(this.state.dateLimitArr) ?
                [getMonth(startOfMonth(new Date(this.specDateEle(this.state.dateLimitArr, 'y'), this.specDateEle(this.state.dateLimitArr, 'm'), this.specDateEle(this.state.dateLimitArr, 'd'))))] :
                [getMonth(startOfMonth(new Date()))],
            selectedMonthStartDate: !commonFunction.isValueEmpty(this.state.dateLimitArr) ? startOfMonth(new Date(this.specDateEle(this.state.dateLimitArr, 'y'), this.specDateEle(this.state.dateLimitArr, 'm'), this.specDateEle(this.state.dateLimitArr, 'd'))) : startOfMonth(startOfToday()),
        })
        if (
            this.state.isDoubleSelection &&
            !commonFunction.isValueEmpty(this.props.startDate) &&
            !commonFunction.isValueEmpty(this.props.endDate)
        ) {
            const nights = differenceInCalendarDays(
                new Date(this.props.endDate),
                new Date(this.props.startDate)
            );
            this.setState({ totalNights: nights > 0 ? nights : '' });
        }
        document.addEventListener('mousedown', this.handleClickOutside);
    }
    componentDidUpdate() {
        if (this.props.endDate !== this.state.endDate) {
            this.setState({ endDate: this.props.endDate });
        }
    }
    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }
    debounce(func, delay) {
        let timeout;
        return function (...args) {
            clearTimeout(timeout);
            timeout = setTimeout(() => func.apply(this, args), delay);
        };
    }
    handleClickOutside = () => {
        if (this.state.isCalendarVisible === true) {
            // If only start date is selected and no end date, set end date as start date + 1 day
            if (this.state.isDoubleSelection && this.state.numberOfClicks === 1 && this.props.startDate && !this.props.endDate) {
                const nextDay = addDays(new Date(this.props.startDate), 1);
                this.props.onChangeDate(nextDay, 'endDate');
                this.setState({ numberOfClicks: 0 });
            }
            this.setState({ isCalendarVisible: false });
        }
    };


    specDateEle(date, type) {
        try {
            let toDefaultFormat = moment(date, this.state.dateFormat);
            let getDate = toDefaultFormat.format(this.state.dateFormat);
            let getYear = typeof date === 'string' ? new Date(getDate).getFullYear() : date.getFullYear();
            let getMonth = typeof date === 'string' ? new Date(getDate).getMonth() : date.getMonth();
            let getDay = typeof date === 'string' ? new Date(getDate).getDate() : date.getDate();
            switch (type) {
                case 'y':
                    return getYear
                case 'm':
                    return getMonth
                case 'd':
                    return getDay
                case 'a':
                    return [getYear, getMonth, getDay];
                default:
            }
        } catch (err) {
            console.log('catch yyyyy', err)
        }
    }
    onClickChangeVisibility = () => {
        if (this.props.isVisible) {
            // If closing and only start date is selected, set end date as start date + 1 day
            if (this.state.isDoubleSelection && this.state.numberOfClicks === 1 && this.props.startDate && !this.props.endDate) {
                const nextDay = addDays(new Date(this.props.startDate), 1);
                this.props.onChangeDate(nextDay, 'endDate');
                this.setState({ numberOfClicks: 0 });
            }
            document.querySelector("body").style.overflow = "auto";
        } else {
            document.querySelector("body").style.overflow = "hidden";
        }
        this.props.changeVisibility(!this.props.isVisible);
    }

    onClickDateCell = (day, month, year, bool) => {
        if (!bool) {
            const date = new Date(year, month, day);

            if (this.state.isDoubleSelection) {
                if (this.state.activeBox === "checkout") {
                    // Only allow changing check-out date
                    if (this.props.startDate) {
                        const nights = differenceInCalendarDays(date, new Date(this.props.startDate));
                        if (nights > 0) {
                            this.setState({
                                endDate: date,
                                numberOfClicks: 0,
                                totalNights: nights
                            }, () => {
                                this.props.onChangeDate(date, 'endDate');
                            });
                        }
                    }
                    return;
                }

                const { startDate, endDate, numberOfClicks } = this.state;

                if (numberOfClicks === 0) {
                    this.setState({
                        startDate: date,
                        endDate: null,
                        numberOfClicks: 1,
                        totalNights: ''
                    }, () => {
                        this.props.onChangeDate(date, 'startDate');
                        this.props.onChangeDate(null, 'endDate');
                    });
                } else if (numberOfClicks === 1) {
                    const nights = differenceInCalendarDays(date, startDate);
                    if (nights > 0) {
                        this.setState({
                            endDate: date,
                            numberOfClicks: 0,
                            totalNights: nights
                        }, () => {
                            this.props.onChangeDate(date, 'endDate');
                        });
                    } else {
                        this.setState({
                            startDate: date,
                            endDate: null,
                            numberOfClicks: 1,
                            totalNights: ''
                        }, () => {
                            this.props.onChangeDate(date, 'startDate');
                            this.props.onChangeDate(null, 'endDate');
                        });
                    }
                }
            } else {
                this.setState({
                    startDate: date,
                    endDate: null,
                    numberOfClicks: 0,
                    totalNights: ''
                }, () => {
                    const dateFormatted = moment(date).format(this.state.dateFormat);
                    this.props.onChangeDate(dateFormatted);
                });
            }
        }
    }

    renderCalendar() {
        const { selectedMonthStartDate, totalMonths, endDate, hoverEndDate, isDoubleSelection, totalDays } = this.state;
        const { value, styles, startDate, startDateLimit, isHoliday, holidayStartDate, holidayEndDate } = this.props;
        let temp = selectedMonthStartDate;
        let twoCalendarsArray = [];

        for (let i = 0; i < totalMonths; i++) {
            const StartDateOfMonth = temp;
            const monthHead = addDays(StartDateOfMonth, i === 0 ? 0 : 1);
            const endDateOfMonth = endOfMonth(monthHead);
            const month = getMonth(monthHead);
            const year = getYear(monthHead);
            let startOfMonthDay = isMonday(monthHead)
                ? 0
                : isTuesday(monthHead)
                    ? 1
                    : isWednesday(monthHead)
                        ? 2
                        : isThursday(monthHead)
                            ? 3
                            : isFriday(monthHead)
                                ? 4
                                : isSaturday(monthHead)
                                    ? 5
                                    : 6;

            const days = [];
            for (let k = 0; k < startOfMonthDay; k++) {
                days.push({ day: "", month, year, isDisable: true, selectedDate: false, highlight: false });
            }

            const startDateObj = new Date(this.specDateEle(startDate, 'y'), this.specDateEle(startDate, 'm'), this.specDateEle(startDate, 'd'));
            const startDateLimitObj = new Date(this.specDateEle(startDateLimit, 'y'), this.specDateEle(startDateLimit, 'm'), this.specDateEle(startDateLimit, 'd'));
            const endDateObj = new Date(this.specDateEle(endDate, 'y'), this.specDateEle(endDate, 'm'), this.specDateEle(endDate, 'd'));
            const hoverDateObj = new Date(this.specDateEle(hoverEndDate, 'y'), this.specDateEle(hoverEndDate, 'm'), this.specDateEle(hoverEndDate, 'd'));

            for (let j = 0; j <= differenceInDays(endDateOfMonth, monthHead); j++) {
                const currentDate = new Date(year, month, j + 1);

                // --- Disable dates before check-in when checkout box is active ---
                if (
                    this.state.activeBox === "checkout" &&
                    this.props.startDate &&
                    isBefore(currentDate, new Date(this.specDateEle(this.props.startDate, 'y'), this.specDateEle(this.props.startDate, 'm'), this.specDateEle(this.props.startDate, 'd')))
                ) {
                    days.push({ day: j + 1, month, year, isDisable: true, selectedDate: false, highlight: false });
                    continue;
                }

                const isBeforeDate = isBefore(currentDate, startDateLimitObj);
                const disableDate = isHoliday && (
                    isBefore(currentDate, new Date(this.specDateEle(holidayStartDate, 'y'), this.specDateEle(holidayStartDate, 'm'), this.specDateEle(holidayStartDate, 'd'))) ||
                    isAfter(currentDate, new Date(this.specDateEle(holidayEndDate, 'y'), this.specDateEle(holidayEndDate, 'm'), this.specDateEle(holidayEndDate, 'd')))
                );

                const isAfterThirtyNights = isAfter(currentDate, addDays(startDateObj, 30));

                if (isBeforeDate || disableDate || (isAfterThirtyNights && this.state.numberOfClicks !== 0)) {
                    days.push({ day: j + 1, month, year, isDisable: true, selectedDate: false, highlight: false });
                } else {
                    const isStartDate = isSameDay(currentDate, startDateObj);
                    const isEndDate = isSameDay(currentDate, endDateObj);
                    // const isHoverDate = isSameDay(currentDate, hoverDateObj);
                    const isAfterDate = isAfter(currentDate, startDateObj);
                    const isBeforeDate = isBefore(currentDate, hoverDateObj);
                    const isBeforeEndDate = isBefore(currentDate, endDateObj);
                    // const isHoverDate = ((isAfterDate && isBeforeDate && commonFunction.isValueEmpty(endDate)) || (isAfterDate && isBeforeEndDate && (!commonFunction.isValueEmpty(endDate))));

                    days.push({
                        day: j + 1,
                        month,
                        year,
                        isDisable: false,
                        selectedDate: isStartDate || isEndDate,
                        highlight: ((isAfterDate && isBeforeDate && commonFunction.isValueEmpty(endDate)) || (isAfterDate && isBeforeEndDate && (!commonFunction.isValueEmpty(endDate))))
                    });
                }
            }

            temp = endDateOfMonth;

            twoCalendarsArray.push(
                <div key={`calendar_${i}`} className={styles.calendar_whole_body}>
                    <div className={styles.calendar_head}>
                        <div className={styles.calendar_head_center_side}>
                            <h3>{format(monthHead, 'MMMM yyyy')}</h3>
                        </div>
                    </div>
                    {/* 👉 Add this block */}
                    <div className={styles.calendar_week_heads}>
                        {weekList.map((ele, ix) => (
                            <div className={styles.coln_center_week} key={`week_${i}_${ix}`}>
                                {ele}
                            </div>
                        ))}
                    </div>
                    <div className={styles.calendar_body}>
                        <div className={styles.calendar_day_list}>
                            {days.map((ele, idx) =>
                            (
                                <div
                                    key={`${ele.year}_${ele.month}_${ele.day}`}
                                    className={`${ele.selectedDate && ele.day ? styles.selected_calendar_date + ' ' + styles.day_cell_center : ele.highlight && ele.day !== '' ? styles.day_cell_center_highlight : styles.day_cell_center}`}
                                    onClick={(e) => { e.stopPropagation(); this.debouncedOnClickDateCell(ele.day, ele.month, ele.year, ele.isDisable) }}
                                    onMouseEnter={(e) => this.onHoverDayCell(ele, e)}
                                >
                                    {isDoubleSelection && !ele.isDisable && !commonFunction.isValueEmpty(hoverEndDate) && this.isHoverDate(ele, hoverEndDate) && !commonFunction.isValueEmpty(totalDays) && <div class={this.props.styles.container_tooltip}>
                                        {/* {totalDays} Night */}
                                    </div>}
                                    <span className={ele.isDisable ? styles.calendar_day_disable : ''}>{ele.day}</span>
                                    {/* {ele.isDisable ? <span className={styles.calendar_day_disable}>{ele.day}</span> : ele.day} */}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            );
        }

        return twoCalendarsArray;
    }

    isHoverDate = (ele, hoverEndDate) => {
        return isSameDay(new Date(ele.year, ele.month, ele.day), new Date(this.specDateEle(hoverEndDate, 'y'), this.specDateEle(hoverEndDate, 'm'), this.specDateEle(hoverEndDate, 'd')))
    }

    onClickDoneBtn = () => {
        // If only start date is selected, set end date as start date + 1 day
        if (this.state.isDoubleSelection && this.state.numberOfClicks === 1 && this.props.startDate && !this.props.endDate) {
            const nextDay = addDays(new Date(this.props.startDate), 1);
            this.props.onChangeDate(nextDay, 'endDate');
            this.setState({ numberOfClicks: 0 });
        }
        this.props.changeVisibility(false);
    }
    // onHoverDayCell = (currentDate, e) => {
    //     let date = moment(new Date(currentDate.year, currentDate.month, currentDate.day)).format(this.props.dateFormat ? this.props.dateFormat : "DD/MMM/yyyy");
    //     this.setState({
    //         hoverEndDate: date
    //     })
    //     if (!commonFunction.isValueEmpty(this.props.startDate) && commonFunction.isValueEmpty(this.state.endDate)) {
    //         this.setState({
    //             hoverEndDate: date, pageX: Number(e.clientX) - Number(this.state.initPageX), pageY: Number(e.clientY) - Number(this.state.initPageY)
    //         }, () => {
    //             let difference = differenceInCalendarDays(new Date(currentDate.year, currentDate.month, currentDate.day), new Date(this.props.startDate))
    //             if (difference > 0) this.setState({ totalDays: difference })
    //             else this.setState({ totalDays: '' })
    //         })
    //     }
    // }

    onHoverDayCell = (currentDate, e) => {
        let date = moment(new Date(currentDate.year, currentDate.month, currentDate.day)).format(this.props.dateFormat ? this.props.dateFormat : "DD/MMM/yyyy");
        this.setState({
            hoverEndDate: date
        })
        if (!commonFunction.isValueEmpty(this.props.startDate) && commonFunction.isValueEmpty(this.state.endDate)) {
            this.setState({
                hoverEndDate: date, pageX: Number(e.clientX) - Number(this.state.initPageX), pageY: Number(e.clientY) - Number(this.state.initPageY)
            }, () => {
                let difference = differenceInCalendarDays(new Date(currentDate.year, currentDate.month, currentDate.day), new Date(this.props.startDate))
                if (difference > 0) this.setState({ totalDays: difference })
                else this.setState({ totalDays: '' })
            })
        }
    }
    onMouseMoveCalendar = (e, eventUsed) => {
        switch (eventUsed) {
            case 'onMouseEnter':
                this.setState({ initPageX: e.clientX, initPageY: e.clientY })
                break;
            default:
                break;
        }
        e.preventDefault()
    }
    selectDateLabelType() {
        let dateLabel = { calaHeadTitle1: "DEPARTURE DATE", calaHeadTitle2: "RETURN DATE" };
        if (this.state.serviceType == "hotel") {
            dateLabel.calaHeadTitle1 = "Check In";
            dateLabel.calaHeadTitle2 = "Check Out";
        } else if (this.state.serviceType == "holiday") {
            dateLabel.calaHeadTitle1 = "START DATE";
            dateLabel.calaHeadTitle2 = "END DATE";
        }
        return dateLabel;
    }
    render() {
        // console.log('calendar_wid_container', this.props)
        // console.log('calendar_wid_container11111', this.state.endDate)
        var idd = 'hotels_chek_in'
        if (this.props?.isCheckIn) {
            idd = 'hotels_chek_in'
        } else {
            idd = 'hotels_chek_out'
        }
        return (
            <div className={this.props.styles.calendar_wid_container} onClick={(e) => { e.stopPropagation(); this.onClickChangeVisibility() }} >
                {<label>{this.props.label}</label>}
                <div className={this.props.styles.calendar_wid_main}>
                    {/* {!commonFunction.isValueEmpty(this.props.iconImage) ? (
                        <img src={this.props.iconImage} className={this.props.styles.flight_search_wid_inputfield_img_cal} alt=""/>
                    ) : null} */}
                    {this.state.isDoubleSelection === true ? (
                        <>
                            <input
                                type='text'
                                autoComplete={'off'}
                                id="myTextField"
                                className="search_widget_input_new"
                                readOnly
                                placeholder={!commonFunction.isValueEmpty(this.props.placholder) ? this.props.placholder : ""}
                                value={
                                    this.props?.isCheckIn && this.props.value
                                        ? `${this.props.value.split("-")[1]} ${this.props.value.split("-")[0]}, ${this.props.value.split("-")[2].trim()}, ${weekday[(this.props?.startDate ? new Date(this.props.startDate) : "").getDay()]}`
                                        : this.props?.isCheckIn === false && this.props.value
                                            ? `${this.props.value.split("-")[4]} ${this.props.value.split("-")[3]}, ${this.props.value.split("-")[5]}, ${weekday[(this.props?.startDate ? new Date(this?.props?.value?.split("-")[3] + "-" + this.props?.value?.split("-")[4] + "-" + this.props?.value?.split("-")[5]) : "").getDay()]}`
                                            : ""
                                }
                                // onClick={(e) => { e.stopPropagation(); this.onClickChangeVisibility() }}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    this.setState(
                                        { activeBox: this.props.isCheckIn ? "checkin" : "checkout" },
                                        () => this.onClickChangeVisibility()
                                    );
                                }}
                            />
                            {/* Show nights only for check-out input */}
                            {!this.props.isCheckIn && (
                                <span className={this.props.styles.calendar_per_night}>
                                    {/* {this.state.totalNights ? `${this.state.totalNights} ${this.state.totalNights > 1 ? 'Nights' : 'Night'}` : ''} */}
                                </span>
                            )}
                        </>
                    ) : (
                        <>
                            {
                                this.props.theme === 'theme2' ?
                                    <div className={this.props.styles.new_cal_main} onClick={(e) => { e.stopPropagation(); this.onClickChangeVisibility() }}>
                                        <div className={this.props.styles.flex_cont_cal}>
                                            <div className={this.props.styles.new_cal_digit}>
                                                <h1 className={this.props.styles.new_cal_digit_text}>{this.props.value ? this.props.value.split('-')[0] : ''}</h1>
                                            </div>
                                            <div className={this.props.styles.new_cal_text}>
                                                <p className={this.props.styles.new_cal_month}>{this.props.value ? this.props.value.split('-')[1] : ''}</p>
                                                <p className={this.props.styles.new_cal_year}>{this.props.value ? this.props.value.split('-')[2] : ''}</p>
                                            </div>
                                        </div>

                                        <div className={this.props.styles.flex_cont_cal}>
                                            <div className={this.props.styles.new_cal_digit}>
                                                <h1 className={this.props.styles.new_cal_digit_text}>{this.props.value ? this.props.value.split('-')[3] : ''}</h1>
                                            </div>
                                            <div className={this.props.styles.new_cal_text}>
                                                <p className={this.props.styles.new_cal_month}>{this.props.value ? this.props.value.split('-')[4] : ''}</p>
                                                <p className={this.props.styles.new_cal_year}>{this.props.value ? this.props.value.split('-')[5] : ''}</p>
                                            </div>
                                        </div>
                                    </div>
                                    :
                                    <input type='text' autoComplete={'off'} id="myTextField" className="search_widget_input_new" readOnly
                                        placeholder={!commonFunction.isValueEmpty(this.props.placholder) ? this.props.placholder : ""}
                                        value={!commonFunction.isValueEmpty(this.props.value) ? this.props.value : ""}
                                        // onClick={(e) => { e.stopPropagation(); this.onClickChangeVisibility() }}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            this.setState(
                                                { activeBox: this.props.isCheckIn ? "checkin" : "checkout" },
                                                () => this.onClickChangeVisibility()
                                            );
                                        }}
                                    />
                            }

                        </>
                    )}
                </div>
                {this.props.isVisible === true ? (
                    <div className={this.props.styles.calendar_wid_container_popup}>
                        <div className={this.props.styles.date_header_container}>
                            <div className={this.props.styles.modal_header}>
                                <span onClick={(e) => {
                                    e.stopPropagation();
                                    this.onClickChangeVisibility()
                                    document.querySelector("body").style.overflow = "auto"
                                }}>
                                    <img src="images/eth_left_arrow.svg" alt="logo" />
                                </span>
                                <p className={this.props.styles.header_text}>Select Date</p>
                            </div>

                            <div className={this.props.styles.search_container}>
                                <span class={this.props.styles.search_icon}><img src="images/eth-search-icon.svg" alt="search" /></span>

                                <input
                                  type="text"
                                  value={
                                    this.props?.startDate
                                      ? (
                                          this.props?.endDate
                                            ? `Check In ${moment(new Date(this.props.startDate)).format("MMM DD, YYYY")} - Check Out ${moment(new Date(this.props.endDate)).format("MMM DD, YYYY")}`
                                            // : `Check In ${moment(new Date(this.props.startDate)).format("MMM DD, YYYY")} - Check Out`
                                            : `Check In ${moment(new Date(this.props.startDate)).format("MMM DD, YYYY")} - Check Out ${moment(addDays(new Date(this.props.startDate), 1)).format("MMM DD, YYYY")}`
                                        )
                                      : ""
                                  }
                                  className={this.props.styles.search_input}
                                  placeholder="Check In Jun 19, 2025 - Check Out Jun 25, 2025"
                                />
                            </div>
                            {/* <div className={this.props.styles.calendar_week_heads}>
                                {weekList.map((ele, ix) => {
                                    return (
                                        <div className={this.props.styles.coln_center_week} key={"th_month_" + ix + "week"}>
                                            {ele}
                                        </div>
                                    )
                                })}
                            </div> */}
                        </div>
                        {/* <img src="/images/download.png" onClick={(e) => { e.stopPropagation(); this.onClickChangeVisibility() }} className={this.props.styles.flight_search_wid_inputfield_img} /> */}
                        {/* <div className={this.props.styles.calendar_modal_close} onClick={(e) => { e.stopPropagation(); this.onClickChangeVisibility() }}>
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path></svg>
                        </div> */}
                        {/* <div className={this.props.styles.calendar_head_container}>
                            <div className={this.props.styles.calendar_head_main}>
                                <div className={this.props.styles.calendar_head_com + " " + this.props.styles.calendar_head_left}>
                                    <span className={this.props.styles.calendar_head_title}>{this.selectDateLabelType()?.calaHeadTitle1}</span>
                                    <h5>{!commonFunction.isValueEmpty(this.props.startDate) ? format(new Date(this.props.startDate), 'dd MMMM yyyy') : 'Select from date'}</h5>
                                </div>
                                <div className={this.props.styles.calendar_head_com + " " + this.props.styles.calendar_head_right}>
                                    <span className={this.props.styles.calendar_head_title}>{this.selectDateLabelType()?.calaHeadTitle2}</span>
                                    <h5>{!commonFunction.isValueEmpty(this.props.endDate) ? format(new Date(this.props.endDate), 'dd MMMM yyyy') : 'Select to date'}</h5>
                                </div>
                            </div>
                        </div> */}
                        <div className={this.props.styles.calendar_main_body_popup}>
                            {this.renderCalendar()}
                        </div>
                        {this.state.endDate != "" ?
                            <div className={this.props.styles.calendar_footer}>
                                <button onClick={(e) => {
                                    e.stopPropagation();
                                    this.onClickDoneBtn();
                                    document.querySelector("body").style.overflow = "auto"
                                }}>Apply Now</button>
                            </div> :
                            <div className={`${this.props.styles.calendar_footer_disable}`}>
                                <button onClick={(e) => {
                                    e.stopPropagation();
                                    // this.onClickDoneBtn() ;
                                    document.querySelector("body").style.overflow = "auto"
                                }}>Apply Now</button>
                            </div>}
                    </div>
                ) : null}
            </div>
        )
    }
}
